import axios from "axios"; //引用axios
import getSign from "./sign.js";

const baseURL = process.env.VUE_APP_BASE_SHARE_API;


export function shareRequest(config) {
  //后期开发如果在多个服务器上调用接口可是实例化多个instance，不同的名字即可
  const instance = axios.create({
    baseURL,
    timeout: 20000,
  });
  //请求拦截
  instance.interceptors.request.use(
    async config => {
      // 添加验签信息
      let params = {};
      if (config.method === "post") {
        params = config.data || {};
      } else {
        params = config.params || {};
      }
      let headerObj = await getSign(params);
      for (var key in headerObj) {
        config.headers[key] = headerObj[key];
      }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  //响应拦截
  instance.interceptors.response.use(
    (res) => {
      return res.data;
    },
    (error) => {
      console.log(error);
    }
  );

  return instance(config);
}
